import { ArtifactEditorEntryPoint } from '@/analytics/enums/artifact-editor.enums'
import { DraftEntryPoint } from '@/analytics/enums/draft.enums'

const kArtifactEditorEntryPoints = new Set<string>(Object.values(ArtifactEditorEntryPoint))

const kEntryPointByDraftEntryPoint: Partial<Record<DraftEntryPoint, ArtifactEditorEntryPoint>> = {
  [DraftEntryPoint.DraftsPage]: ArtifactEditorEntryPoint.DraftPage,
  [DraftEntryPoint.MatterActivity]: ArtifactEditorEntryPoint.MatterActivity,
}

/** React Router location.state key read when ArtifactEditorOpened emits. */
export type ArtifactEditorLocationState = {
  artifactEditorEntryPoint?: string
}

/** Adds the editor entry point for a draft opened from outside the chat. The carousel has no entry, so its state is unchanged and the editor resolves direct. */
export function draftNavigationState(draftEntryPoint: DraftEntryPoint, state: { scrollToMatterArtifactVersionId: string }) {
  const entryPoint = kEntryPointByDraftEntryPoint[draftEntryPoint]
  return entryPoint ? artifactEditorNavigationState(entryPoint, state) : state
}

/**
 * Merges the entry point into an existing navigation state. A prior scroll target stays put.
 * A later open replaces a stale entry point.
 */
export function artifactEditorNavigationState(entryPoint: ArtifactEditorEntryPoint, state?: unknown): Record<string, unknown> {
  const prior = state != null && typeof state === 'object' ? (state as Record<string, unknown>) : {}
  return { ...prior, artifactEditorEntryPoint: entryPoint }
}

/**
 * Accepts a known ArtifactEditorEntryPoint and falls back to direct for missing or invalid
 * state. A browser refresh keeps history.state, so it is not direct.
 */
export function resolveArtifactEditorEntryPoint(source: string | null | undefined): ArtifactEditorEntryPoint {
  if (source != null && kArtifactEditorEntryPoints.has(source)) {
    return source as ArtifactEditorEntryPoint
  }
  return ArtifactEditorEntryPoint.Direct
}
